import getSymbolFromCurrency from "currency-symbol-map";

const PRICE_FRACTION = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

export function formatPrice(value, currency) {
    if (value == null) return "";
    const symbol = currency ? getSymbolFromCurrency(currency) ?? "" : "";
    return `${symbol}${Number(value).toLocaleString(undefined, PRICE_FRACTION)}`;
}

export function formatCarat(value) {
    if (value == null) return "";
    return Number(value).toFixed(2);
}

export function formatPercent(value) {
    if (value == null) return "0";
    return Number(value).toFixed(2);
}

export function formatRatio(value) {
    if (value == null) return null;
    return `R:${Number(value).toFixed(2)}`;
}
